
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { ChatAlt2Icon, ChevronRightIcon, FilmIcon, MicrophoneIcon, PhotographIcon, SpeakerphoneIcon, TemplateIcon, } from '@heroicons/react/solid';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import * as React from 'react';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import ButtonLink from '@/components/links/ButtonLink';
import Seo from '@/components/Seo';
// Labels are keys in the `footer` namespace so they reuse existing translations
const popularPages = [
    { name: 'Chat with AI', href: '/marky', icon: ChatAlt2Icon },
    { name: 'AI Images', href: '/ai-image-generator', icon: PhotographIcon },
    { name: 'AI Videos', href: '/ai-video-generator', icon: FilmIcon },
    {
        name: 'AI Text-to-Speech',
        href: '/text-to-speech',
        icon: SpeakerphoneIcon,
    },
    { name: 'AI Transcription', href: '/ai-transcription', icon: MicrophoneIcon },
    { name: 'Templates', href: '/templates', icon: TemplateIcon },
];
export default function NotFoundPage() {
    const { t } = useLocale('common');
    const { t: tFooter } = useLocale('footer');
    return (<main className='bg-white dark:bg-slate-900'>
      <Seo templateTitle='Page Not Found' robots='noindex, follow'/>

      <div className='relative z-10 bg-white dark:bg-slate-900 sm:pb-8'>
        <LandingPageNavigation />
      </div>

      <section className='mx-auto flex w-full max-w-2xl flex-col justify-center px-4 pb-16 pt-10 sm:px-6 sm:pb-24 sm:pt-16 lg:px-8'>
        <p className='text-center text-base font-semibold text-primary-600 dark:text-primary-400'>
          404
        </p>
        <h1 className='mt-2 text-center text-4xl font-extrabold tracking-tight text-gray-900 dark:text-slate-200 sm:text-5xl'>
          {t('Page not found')}
        </h1>
        <p className='mt-4 text-center text-lg text-gray-500 dark:text-slate-400'>
          {t("Sorry, we couldn't find the page you're looking for.")}
        </p>

        <div className='mt-8 flex flex-wrap items-center justify-center gap-4'>
          <ButtonLink href='/' variant='primary'>
            {t('Back to Home')}
          </ButtonLink>
          <ButtonLink href='/contact' variant='ghost'>
            {tFooter('Contact Us')}
          </ButtonLink>
        </div>

        <div className='mt-14'>
          <h2 className='text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-slate-400'>
            {t('Popular tools')}
          </h2>
          <ul className='mt-4 divide-y divide-gray-100 border-y border-gray-100 dark:divide-slate-800 dark:border-slate-800'>
            {popularPages.map((page) => (<li key={page.href}>
                <Link href={page.href} className='group flex items-center gap-4 py-4'>
                  <span className='flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 dark:bg-slate-800'>
                    <page.icon className='h-5 w-5 text-primary-600 dark:text-primary-400' aria-hidden='true'/>
                  </span>
                  <span className='flex-1 text-base font-medium text-gray-900 group-hover:text-primary-600 dark:text-slate-200 dark:group-hover:text-primary-400'>
                    {tFooter(page.name)}
                  </span>
                  <ChevronRightIcon className='h-5 w-5 text-gray-400 transition-transform duration-150 group-hover:translate-x-0.5 group-hover:text-primary-600 dark:text-slate-500 dark:group-hover:text-primary-400' aria-hidden='true'/>
                </Link>
              </li>))}
          </ul>
        </div>
      </section>

      <Footer />
    </main>);
}

    async function __Next_Translate__getStaticProps__1a11b03d42a__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/404',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d42a__ as getStaticProps }
  